import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class MasterService {

  constructor(private http: HttpClient) { }

  public GetProductActicationList(school: string, mobile: string, serial: string) {

    return this.http.get(environment.apiUrl + "GetProductNotActivatedList?schoolname=" + school + "&mobile=" + mobile + "&serial=" + serial + "")
  }
  public AddProductActivationKey(data: number[], actkey: string) {
    return this.http.post(environment.apiUrl + "AddProductActivationKey/" + actkey, data)
  }

  public GetProductNotActivatedListNew(school: string, mobile: string, serial: string) {

    return this.http.get(environment.apiUrl + "GetProductNotActivatedListNew?schoolname=" + school + "&mobile=" + mobile + "&serial=" + serial + "")
  }
  public AddProductActivationKeyNew(data: number[], actkey: string) {
    return this.http.post(environment.apiUrl + "AddProductActivationKeyNew/" + actkey, data)
  }
  public DeleteOldActivation(data) {
    return this.http.post(environment.apiUrl + "DeleteOldActivation", data)
  }

  public GetProductNotActivatedListToRemove(school: string, mobile: string, serial: string) {
    return this.http.get(environment.apiUrl + "GetProductNotActivatedListToRemove?schoolname=" + school + "&mobile=" + mobile + "&serial=" + serial + "")
  }

}
